import ActionTypes from './actionTypes';

export function searchAllUsers(
  searchTerm='',
  pageNumber,
  pageSize,
  sortType = 'familyName',
  ascending = true,
  firstName = '',
  lastName = '',
  email = '',
  accountNumber = '',
) {
  return {
    type: ActionTypes.USERS.SEARCH_ALL_USERS.REQUEST,
    payload: {
      searchTerm,
      pageNumber,
      pageSize,
      sortColumn: sortType,
      sortDirection: ascending ? 'ASC' : 'DESC',
      firstName,
      lastName,
      email,
      accountNumber,
    },
  };
}

export function searchAllUsersReset() {
  return {
    type: ActionTypes.USERS.SEARCH_ALL_USERS.RESET,
  };
}

export function searchAllImpersonateUsers(searchTerm) {
  return {
    type: ActionTypes.USERS.SEARCH_ALL_IMPERSONATE_USERS.REQUEST,
    payload: {
      searchTerm,
      pageNumber: 1,
      pageSize: 99,
      sortColumn: 'givenName',
      sortDirection: 'DESC',
    },
  };
}

export function searchAllImpersonateUsersReset() {
  return {
    type: ActionTypes.USERS.SEARCH_ALL_IMPERSONATE_USERS.RESET,
  };
}

export function impersonateUser(userId) {

  return {
    type: ActionTypes.USERS.IMPERSONATE_USER.REQUEST,
    payload: {
      userId: userId,
    },
  };
}

export function lookUpUserByEmailId(emailId) {
  return {
    type: ActionTypes.USERS.EMAIL_LOOKUP.REQUEST,
    payload: {
      emailId: emailId,
    },
  };
}

export function resetUserEmailLookup() {
  return {
    type: ActionTypes.USERS.EMAIL_LOOKUP.RESET,
  };
}

export function loginUser() {
  return {
    type: ActionTypes.USERS.LOGIN_USER.REQUEST,
  };
}

export function getUserDetails() {
  return {
    type: ActionTypes.USERS.ME.REQUEST,
  };
}


export function getDetailedUser(userId, grandParentCustomerNumber) {
  return {
    type: ActionTypes.USERS.DETAILED_FETCH.REQUEST,
    payload: { userId, grandParentCustomerNumber }
  };
}

export function adminGetDetailedUser(userId) {
  return {
    type: ActionTypes.USERS.ADMIN_DETAILED_FETCH.REQUEST,
    payload: { userId }
  };
}

export function resetDetailedUser() {
  return {
    type: ActionTypes.USERS.DETAILED_FETCH.RESET,
  };
}

export function resetAdminDetailedUser() {
  return {
    type: ActionTypes.USERS.ADMIN_DETAILED_FETCH.RESET,
  };
}

export function searchUsersWithCriteria(
  clientId,
  pageNumber,
  pageSize,
  sortType = 'familyName',
  ascending = true,
  searchTerm = '',
  firstName = '',
  lastName = '',
  email = '',
  roleId = '',
  numberOfAccounts = null,
  status = ''
) {
  return {
    type: ActionTypes.USERS.FETCH.REQUEST,
    payload: {
      clientId,
      pageNumber,
      pageSize,
      sortType ,
      ascending,
      searchTerm,
      firstName,
      lastName,
      email,
      roleId,
      numberOfAccounts,
      status
    },
  };
}

export function searchUsersReset() {
  return {
    type: ActionTypes.USERS.FETCH.RESET,
  };
}

export function createUser(
  clientId,
  givenName,
  familyName,
  emailId,
  assignedRoleId,
  assignedAccounts
) {
  let createUserRequest = JSON.stringify({
    givenName: givenName,
    familyName: familyName,
    emailId: emailId,
    assignedRoleId: assignedRoleId,
    assignedAccounts: assignedAccounts,
  });

  return {
    type: ActionTypes.USERS.CREATE.REQUEST,
    payload: { clientId, createUserRequest },
  };
}

export function createUserReset() {
  return {
    type: ActionTypes.USERS.CREATE.RESET,
  };
}

export function updateUser(
  userId,
  grandParentCustomerNumber,
  updateUserProfileRequest
) {
  return {
    type: ActionTypes.USERS.UPDATE.REQUEST,
    payload: { userId, grandParentCustomerNumber, updateUserProfileRequest },
  };
}

export function updateUserReset() {
  return {
    type: ActionTypes.USERS.UPDATE.RESET,
  };
}

export function adminUpdateUser(
  userId,
  updateUserProfileRequest
) {
  return {
    type: ActionTypes.USERS.ADMIN_UPDATE_USER.REQUEST,
    payload: { userId, updateUserProfileRequest },
  };
}

export function adminUpdateUserReset() {
  return {
    type: ActionTypes.USERS.ADMIN_UPDATE_USER.RESET,
  };
}

export function updateUserProfileSelf(
  userId,
  grandParentCustomerNumber,
  updateUserProfileRequest
) {
  return {
    type: ActionTypes.USERS.UPDATE_USER_SELF.REQUEST,
    payload: { userId, grandParentCustomerNumber, updateUserProfileRequest },
  };
}

export function updateUserProfileSelfReset() {
  return {
    type: ActionTypes.USERS.UPDATE_USER_SELF.RESET,
  };
}

export function assignAccountsToUser(
  grandParentCustomerNumber,
  userId,
  assignAccountsUserMap,
  accountDeselection,
  assignedClientRoles,
) {
  return {
    type: ActionTypes.USERS.ASSIGN_ACCOUNTS.REQUEST,
    payload: { userId, grandParentCustomerNumber, assignAccountsUserMap, accountDeselection, assignedClientRoles },
  };
}

export function assignAccountsToUserReset() {
  return {
    type: ActionTypes.USERS.ASSIGN_ACCOUNTS.RESET
  };
}

export function updateAdminAssignAccountsToUserRequest(
  assignAccountsRequest,
) {
  return {
    type: ActionTypes.USERS.UPDATE_ASSIGN_ACCOUNTS_REQUEST,
    payload: { assignAccountsRequest },
  };
}

export function deleteUser(clientId, userId) {
  return {
    type: ActionTypes.USERS.DELETE.REQUEST,
    payload: {
      clientId,
      userId
    },
  };
}

export function deleteUserReset() {
  return {
    type: ActionTypes.USERS.DELETE.RESET,
  };
}

export function adminDeleteUser(userId) {
  return {
    type: ActionTypes.USERS.ADMIN_DELETE_USER.REQUEST,
    payload: {
      userId
    },
  };
}

export function adminDeleteUserReset() {
  return {
    type: ActionTypes.USERS.ADMIN_DELETE_USER.RESET,
  };
}

export function downloadUsers(
  clientId,
  searchTerm = '',
  firstName = '',
  lastName = '',
  email = '',
  roleId = '',
  numberOfAccounts = null,
  status = ''
) {
  return {
    type: ActionTypes.USERS.DOWNLOAD.REQUEST,
    payload: {
      clientId,
      searchTerm,
      firstName,
      lastName,
      email,
      roleId,
      numberOfAccounts,
      status
    },
  };
}

export function downloadUsersSuccess() {
  return {
    type: ActionTypes.USERS.DOWNLOAD.SUCCESS
  };
}

export function downloadUsersFailure() {
  return {
    type: ActionTypes.USERS.DOWNLOAD.FAILURE
  };
}

export function downloadAllUsers(
  searchTerm = '',
  firstName = '',
  lastName = '',
  email = '',
) {
  return {
    type: ActionTypes.USERS.DOWNLOAD_ALL_USERS.REQUEST,
    payload: {
      searchTerm,
      firstName,
      lastName,
      email,
    },
  };
}

export function downloadAllUsersSuccess() {
  return {
    type: ActionTypes.USERS.DOWNLOAD_ALL_USERS.SUCCESS
  };
}

export function downloadAllUsersFailure() {
  return {
    type: ActionTypes.USERS.DOWNLOAD_ALL_USERS.FAILURE
  };
}

export function setAssignedGrandparentAccount(payload) {
  return {
    type: ActionTypes.USERS.SET_ASSIGNED_GRANDFATHER_DETAILS,
    payload: payload,
  };
}

export function setCanReadWrite(payload) {
  return {
    type: ActionTypes.USERS.SET_CAN_READ_WRITE,
    payload: payload,
  };
}
export function setUserAsAmpolAdmin() {
  return {
    type: ActionTypes.USERS.SET_USER_AS_ADMIN,
  };
}

export function setPortalType(payload) {
  return {
    type: ActionTypes.USERS.SET_PORTAL_TYPE,
    payload: payload,
  };
}

export function getAssignedPortalAccountsList(userId, pageSize, offset, sortColumn, sortDirection, searchTerm) {
  return {
    type: ActionTypes.USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.REQUEST,
    payload: {
      userId,
      pageSize,
      offset,
      sortColumn,
      sortDirection,
      searchTerm
    },
  };
}

export function getAssignedPortalAccountsListSuccess(response) {
  return {
    type: ActionTypes.USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.SUCCESS,
    payload: {
      assignedPortalAccountsList: response.result,
      assignedPortalAccountsListResultSize: response.resultSize
    },
  };
}

export function getAssignedPortalAccountsListFailure() {
  return {
    type: ActionTypes.USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.FAILURE
  };
}

export function removeAccountAccessForUser(userId, accountNumber, grandParentAccountNumber, isLastAccount) {
  return {
    type: ActionTypes.USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.REQUEST,
    payload: {
      userId,
      accountNumber, 
      grandParentAccountNumber,
      isLastAccount,
    },
  };
}

export function removeAccountAccessForUserSuccess(isLastAccount) {
  return {
    type: ActionTypes.USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.SUCCESS,
    payload: {
      isLastAccount,
    }
  };
}

export function removeAccountAccessForUserFailure() {
  return {
    type: ActionTypes.USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.FAILURE
  };
}

export function removeAccountAccessForUserReset() {
  return {
    type: ActionTypes.USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.RESET
  };
}

export function logout() {
  return {
    type: ActionTypes.USERS.LOGOUT.REQUEST
  };
}

export function searchUserExists(clientId, email) {
  return {
    type: ActionTypes.USERS.SEARCH_USER_EXISTS.REQUEST,
    payload: {
      clientId,
      pageNumber: 1,
      pageSize: 10,
      sortType: 'familyName',
      ascending: true,
      searchTerm: '',
      firstName: '',
      lastName: '',
      email,
      roleId: '',
      numberOfAccounts: null,
      status: '',
    },
  };
}

export function adminSearchUserExists(email) {
  return {
    type: ActionTypes.USERS.ADMIN_SEARCH_USER_EXISTS.REQUEST,
    payload: {
      searchTerm: '',
      pageNumber: 1,
      pageSize: 10,
      sortColumn: 'familyName',
      sortDirection: 'DESC',
      firstName: '',
      lastName: '',
      email,
      accountNumber: '',
    },
  };
}

export function setUserAsUnauthorised() {
  return {
    type: ActionTypes.USERS.SET_USER_AS_UNAUTHORISED,
  };
}
